// extracted by mini-css-extract-plugin
module.exports = {"container":"DetailsTable_container__2EAMI","detailsTable":"DetailsTable_detailsTable__3aIg8","key":"DetailsTable_key__3M4zR","value":"DetailsTable_value__243WT"};